import React, { useEffect, useState, useRef } from 'react'
import WithHOC from './actions'
import { Table, Typography, Button, Row, Col, Modal, Space, Input, Badge } from 'antd'
import { 
  PlusOutlined, 
  CheckCircleFilled,
  CloseCircleFilled, 
  EditTwoTone, 
  DeleteTwoTone, 
  SettingTwoTone, 
  CheckCircleTwoTone,
  NotificationTwoTone,
 } from '@ant-design/icons'
import LoadingOverlay from 'components/LoadingOverlay'
import { useTranslation } from "react-i18next";
import { formatDateTime } from 'utils/dateFormat'
import AddDeviceModal from './AddDeviceModal'
import UpdateDeviceModal from './UpdateDeviceModal'
import { Container } from 'react-bootstrap'
import ConfigureDeviceModal from './ConfigureDeviceModal'
import CheckDeviceConfigModal from './CheckDeviceConfigModal'
import DeviceDebugModal from './DeviceDebugModal'

import { getItem } from 'utils/tokenStore'
import getWebsocketServer from 'utils/websocket'

import Paho from 'paho-mqtt'
import { requestSuccess } from 'utils/requestHandler'

let client = null
const INACTIVITY_THRESHOLD = 10000;

// Bits/sec (not bytes - matches standard network throughput convention),
// auto-scaled to a readable unit.
const formatBitrate = (bps) => {
  if (!bps) return '-';
  if (bps >= 1000000) return `${(bps / 1000000).toFixed(2)} Mbps`;
  if (bps >= 1000) return `${(bps / 1000).toFixed(2)} Kbps`;
  return `${bps} bps`;
};

const Devices = props => {
  const { t } = useTranslation();
  const [deviceConfMac,setDeviceMac] = useState(null)
  const [isActive, setIsActive] = useState(true);
  const [clientId, setClientId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [deviceRates, setDeviceRates] = useState({});
  const [deviceTemperature, setDeviceTemperature] = useState({});
  const messageBytesRef = useRef({}); // mac -> payload bytes received since the last 1s tick
  const [deviceConfData, setDeviceConfData] = useState([]);

  const onSearch = (value) => setSearchText(value.toLowerCase());

  const filteredDevices = props.devices.filter((device) => {
    return (
      device.MAC.toLowerCase().includes(searchText) ||
      device.NAME?.toLowerCase().includes(searchText) ||
      device.ROOM_NAME?.toLowerCase().includes(searchText) ||
      device.DESCRIPTION?.toLowerCase().includes(searchText)
    );
  });

  useEffect(() => {

    if (getItem("LOGIN_TOKEN") && clientId == null){
			props.getMQTTClientID()
		}
    
    const handleVisibilityChange = () => {
      setIsActive(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const doFail = (e) => {
    console.error("Connection failed:", e);
  };

  const configureDevice = (device) => {
    setDeviceMac(device.MAC)
    console.log("Configure... MQTT")
    setConfigureVisible(false)
    publishToMQTT(device.CONFIGURATION,"/GMT/DEV/"+device.MAC+"/C/SAVECFG")
  }

  const checkDeviceConfig = (device) => {
    setDeviceMac(device.MAC)
    console.log("Check Config... MQTT")
    publishToMQTT(device.MAC,"/GMT/DEV/"+device.MAC+"/requestCfg")
  }
  
  useEffect(() => {
    if (getItem("LOGIN_TOKEN") && props.client_id != null && props.updateConfigFlag > 0){
      configureDeviceMQTT()
      // publishToMQTT(props.selectedDevice.MAC,"/GMT/DEV/UPDATE_DEVICE")
    }
  }, [props.updateConfigFlag]);


  useEffect(() => {
    if (getItem("LOGIN_TOKEN") && props.client_id != null && props.checkConfigFlag > 0){
      checkDeviceConfigMQTT()
    }
  }, [props.checkConfigFlag])

  const configureDeviceMQTT = () => {
    console.log("Configure... MQTT")
    publishToMQTT(props.selectedDevice.MAC,"/GMT/DEV/UPDATE_DEVICE")
  }

  const checkDeviceConfigMQTT = () => {
    console.log("Check Config... MQTT")
    publishToMQTT(props.selectedDevice.MAC,"/GMT/DEV/"+props.selectedDevice.MAC+"/checkDeviceCfg")
  }

  const publishToMQTT = (msg, topic) => {
    let message = new Paho.Message(msg);
    message.destinationName = topic;
    message.qos = 1; // or 2
    console.log("Publishing to MQTT topic:", topic, "Message:", msg);
    client.send(message);
  }

  const onMessageArrived = async (message) => {
    try {
      if(message.destinationName.includes("/RAW/") || message.destinationName.includes("/PRE")){
        // Just tally payload bytes here - computing a rate from the gap
        // between any two consecutive messages is noisy (a quick
        // back-to-back pair spikes it wildly). The 1s tick interval turns
        // this byte count into an actual bits-per-second figure and resets it.
        let mac = message.destinationName.split("/")[3]
        const byteLength = message.payloadBytes
          ? message.payloadBytes.length
          : new Blob([message.payloadString || '']).size
        messageBytesRef.current[mac] = (messageBytesRef.current[mac] || 0) + byteLength
      }
      if(message.destinationName.includes("UPDATE_DEVICE")){
        requestSuccess("Updated MAC info") 
      }
      if(message.destinationName.includes("DECODE_PUBLISH/R")){
        if(!message.payloadString.includes("CONNECTED")){
          requestSuccess("Process DP Status: "+ message.payloadString)
        }    
      }
      if(message.destinationName.includes(`/C/SAVECFG`)){
        let mac = message.destinationName.split("/")[3]
        requestSuccess(`Publishing ${mac} data for configuration`)
      }
      if (message.destinationName.includes(`/requestCfg`)){
        let mac = message.destinationName.split("/")[3]
        console.log("Check Topic: "+ message.destinationName, "Message: "+ message.payloadString)
        requestSuccess(`Requesting ${mac} data for configuration`)
      }
      if (message.destinationName.includes(`/RETURN/TEMPERATURE`)){
        let mac = message.destinationName.split("/")[3]
        const payload = JSON.parse(message.payloadString);
        // console.log("Temperature Topic: "+ message.destinationName, "Message: "+ message.payloadString)
        setDeviceTemperature((prevRates) => {
          // console.log(prevRates)
          return {
            ...prevRates,
            [mac]: {
              rate: payload.temperature,
              humidity: payload.humidity,
              pressure: payload.pressure,
              gas_resistance: payload.gas_resistance,
            },
          };
        });
      }

      const parts = message.destinationName.split("/")
      if (
          parts[1] === "GMT" &&
          parts[2] === "DEV" &&
          parts[3] === deviceConfMac &&
          parts[4] === "R"
      ) {
        let mac = message.destinationName.split("/")[3]
        requestSuccess(`Process Status R for ${mac}: `+ message.payloadString)
      }

      if(message.destinationName.includes(`GMT/DEV/${deviceConfMac}/returnCfg`)){
        let mac = message.destinationName.split("/")[3]
        requestSuccess(`Retrieve Config for ${mac}: `+ message.payloadString)
        let data = deviceConfData
        data.push("[" + mac + "] " + message.payloadString)
        setDeviceConfData(data)
      }

    } catch (error) {
      console.error("Error processing MQTT message:", error);
    }
  };

  useEffect(() => {
    const connectToBroker = async () => {
      try {
        const brokerUrl = getWebsocketServer();  // Include the path if required
        client = new Paho.Client(brokerUrl, clientId);
        
        await client.connect({
          timeout: 3,
          onSuccess: () => {
            console.log("Connected");
            client.subscribe("/GMT/DEV/+/DATA/+/JSON");
            client.subscribe("/GMT/DEV/UPDATE_DEVICE");
            client.subscribe("/GMT/DEV/+/C/SAVECFG");
            client.subscribe("/GMT/DEV/+/requestCfg");
            client.subscribe("/GMT/DEV/+/RETURN/TEMPERATURE");
            client.subscribe("/GMT/#");
            client.onMessageArrived = onMessageArrived;
          },
          onFailure: doFail,
          userName: getItem("Username"),
          password: "c764eb2b5fa2d259dc667e2b9e195218",
        });
      } catch (error) {
        console.error("Error connecting to MQTT broker:", error);
      }
    };

    if (getItem("LOGIN_TOKEN") && clientId != null){
      connectToBroker();

      let intervalId;
      let deviceRateIntervalId;

      const startInterval = () => {
        intervalId = setInterval(() => {
          // Your interval function here
          console.log('Interval function running');
          connectToBroker();
        }, 1000 * 60 * 10); // Adjust the interval time as needed
      };

      const stopInterval = () => {
        clearInterval(intervalId);
      };

      // DATA_RATE/TEMPERATURE are rendered straight from deviceRates/deviceTemperature
      // state (updated here and by onMessageArrived) - deliberately does NOT
      // read/write props.devices here, unlike the old version of this interval.
      // That used to close over a stale snapshot of props.devices (this effect
      // doesn't depend on it, so the closure never saw updates), which clobbered
      // the REST-polled device list with old data.
      //
      // DATA_RATE is a throughput figure (bits/sec, from payload bytes received
      // during the PREVIOUS 1s window) - not a message count, and not computed
      // from the gap between two arbitrary messages (which spikes wildly when
      // messages happen to arrive close together) - so it updates once a
      // second, not once per message.
      const rateTickInterval = () => {
        deviceRateIntervalId = setInterval(() => {
          const now = Date.now();
          const byteCounts = messageBytesRef.current;
          messageBytesRef.current = {};

          setDeviceRates((prevRates) => {
            const updatedRates = { ...prevRates };
            const macs = new Set([...Object.keys(prevRates), ...Object.keys(byteCounts)]);
            macs.forEach((mac) => {
              const bytes = byteCounts[mac] || 0;
              updatedRates[mac] = {
                bitsPerSecond: bytes * 8,
                lastTimestamp: bytes > 0 ? now : (prevRates[mac]?.lastTimestamp || now),
              };
            });
            return updatedRates;
          });
        }, 1000);
      };

      const stopRateTickInterval = () => {
        clearInterval(deviceRateIntervalId);
      };

      if (isActive) {
        startInterval();
        rateTickInterval();
      } else {
        stopInterval();
        stopRateTickInterval();
      }

      return () => {
        stopInterval();
        stopRateTickInterval();
      };
    }
  }, [deviceConfMac,isActive, clientId]); // Include dependencies if needed

  useEffect(() => {
    return () => {
      if (client && client.isConnected()) {
        client.disconnect();
        console.log("Disconnected from MQTT broker");
      }
    };
  }, []);

  const [addVisible, setAddVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const [configureVisible, setConfigureVisible] = useState(false);
  const [checkDeviceConfigVisible, setCheckDeviceConfigVisible] = useState(false);
  const [checkDeviceDebugVisible, setCheckDeviceDebugVisible] = useState(false);

  const timezoneOffset = new Date().getTimezoneOffset();

  const columns = [ 
    { 
      key: "Id", 
      title: t("DevicePage.table.id"), 
      dataIndex: "Id",
      sorter: (a, b) => a.Id - b.Id, 
    }, 
    { 
      key: "MAC", 
      title: t("DevicePage.table.mac"), 
      dataIndex: "MAC", 
    }, 
    { 
      key: "NAME", 
      title: t("DevicePage.table.name"), 
      dataIndex: "NAME", 
    },
    { 
      key: "ROOM_NAME", 
      title: t("DevicePage.table.location"), 
      dataIndex: "ROOM_NAME", 
    },
    { 
      key: "TYPE", 
      title: t("DevicePage.table.type"), 
      render: (_, device) => (
        device.TYPE==="1"? t("deviceType.cliff") :
        device.TYPE==="2"? t("deviceType.ceil") :
        device.TYPE==="3"? t("deviceType.vibs") :
        device.TYPE==="4"? t("deviceType.alarm") :
        device.TYPE==="5"? t("deviceType.lidar") : t("deviceType.none")
      ),
    },
    { 
      key: "STATUS", 
      title: t("DevicePage.table.status"), 
      render: (_, device) => (
          device.STATUS!=="DISCONNECTED"
            ? <CheckCircleFilled style={{color:'green'}} />
            : <CloseCircleFilled style={{color:'red'}} />
      ),
    },
    { 
      key: "POS", 
      title: t("DevicePage.table.position"), 
      render: (_, device) => (
        <>{device.DEPLOY_X}, {device.DEPLOY_Y}, {device.DEPLOY_Z}</>
      ),
    },
    { 
      key: "ROT", 
      title: t("DevicePage.table.rotation"), 
      render: (_, device) => (
        <>{device.ROT_X}, {device.ROT_Y}, {device.ROT_Z}</>
      ),
    },
    { 
      key: "MOD", 
      title: t("DevicePage.table.lastModified"), 
      render: (_, device) => (
        <>{formatDateTime(device["LAST DATA"])}</>
      ),
    },
    { 
      key: "DESCRIPTION", 
      title: t("DevicePage.table.description"), 
      dataIndex: "DESCRIPTION", 
    },
    {
      key: "DATA_RATE",
      title: t("DevicePage.table.dataRate"),
      render: (_, device) => {
        const rateInfo = deviceRates[device.MAC];
        const isStale = !rateInfo || (Date.now() - rateInfo.lastTimestamp > INACTIVITY_THRESHOLD);
        const bitsPerSecond = isStale ? 0 : rateInfo.bitsPerSecond;
        return <>{formatBitrate(bitsPerSecond)}</>;
      },
    },
    {
      key: "TEMPERATURE",
      title: t("DevicePage.table.temperature"),
      render: (_, device) => (
        <>{deviceTemperature[device.MAC]?.rate || '-'} °C</>
      ),
    },
    { 
      key: "ACT", 
      title: t("DevicePage.table.action"), 
      render: (_, device) => (
        <Space>
          <EditTwoTone onClick={() => {
            props.onChangeHOC('selectedDevice', device);
            showUpdateModal();
          }} />

          <DeleteTwoTone onClick={() => 
            Modal.confirm({
              title: t("DevicePage.deleteDeviceModal.title"),
              content: t("DevicePage.deleteDeviceModal.content", { name: device.NAME }),
              okText: t("Confirm"),
              cancelText: t("Cancel"),
              onOk: () => props.deleteDevice(device),
            })
          } />

          <SettingTwoTone onClick={() => {
            props.onChangeHOC('selectedDevice', device);
            showConfigureModal();
          }} />

          <CheckCircleTwoTone onClick={() => {
            props.onChangeHOC('selectedDevice', device);
            showCheckDeviceConfigModal();
          }} />

          <Badge dot={device.HAS_RECENT_ERROR} offset={[-2, 2]}>
            <NotificationTwoTone onClick={() => {
              props.onChangeHOC('selectedDevice', device);
              showCheckDeviceDebugModal();
            }} />
          </Badge>
        </Space>
      ),
    },
  ];

  const { Title } = Typography

  const showAddModal = () => {
    setAddVisible(true);
  };

  const closeAddModal = () => {
    setAddVisible(false);
  };

  const showConfigureModal = () => {
    setConfigureVisible(true);
  };

  const closeConfigureModal = () => {
    setConfigureVisible(false);
  };

  const showCheckDeviceDebugModal = () => {
    setCheckDeviceDebugVisible(true);
  }

  const closeCheckDeviceDebugModal = () => {
    setCheckDeviceDebugVisible(false);
  }

  const showCheckDeviceConfigModal = () => {
    setCheckDeviceConfigVisible(true);
  }

  const closeCheckDeviceConfigModal = () => {
    setCheckDeviceConfigVisible(false);
    setDeviceConfData([]);
  }

  const closeUpdateModal = () => {
    setUpdateVisible(false);
  };

  const showUpdateModal = () => {
    setUpdateVisible(true);
  };

	useEffect(() => {
    if (getItem("LOGIN_TOKEN")){
      props.getDevices()
      props.suggestRoom('')
    }

	}, [])

  // Keep the device list (status, last data, error badge, etc.) fresh
  // without needing a manual page refresh. Silent loader so this doesn't
  // flash the page overlay, and skipped while the tab isn't visible.
  useEffect(() => {
    if (!getItem("LOGIN_TOKEN")) return;

    const pollDevices = setInterval(() => {
      if (getItem("LOGIN_TOKEN") && !document.hidden) {
        props.getDevices(() => {});
      }
    }, 5000);

    return () => clearInterval(pollDevices);
  }, []);

  useEffect(() => {
    if (props.client_id){
      setClientId(props.client_id)
    }
    
	}, [props.client_id])

  useEffect(() => {
		if (getItem("LOGIN_TOKEN") && clientId){
			props.setClientConnection(clientId)
			let intervalId;
      const startInterval = () => {
        intervalId = setInterval(() => {
          if (getItem("LOGIN_TOKEN")){
						props.setClientConnection(props.client_id)
					}
        }, 1000 * 60 * 2); // Adjust the interval time as needed
      };
      startInterval();

      return () => {
        clearInterval(intervalId);
      };
		}
  }, [props.client_id]);

	return (
		<Container>
      <Row style={{ alignItems: "center" }}>
        <Col sm={12}>
          <Title>{t("DevicePage.title")}</Title>
        </Col>
        <Col sm={12}>
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            style={{ background: "#1890ff", borderColor: "#1890ff", float: "right" }}
            onClick={showAddModal}
          >
            {t("DevicePage.addDevice")}
          </Button>
        </Col>
      </Row>

      <Row style={{ margin: "16px 0" }}>
        <Col sm={12}>
          <Input.Search
            placeholder={t("DevicePage.searchPlaceholder")}
            enterButton
            onSearch={onSearch}
          />
        </Col>
      </Row>

      <Table
        dataSource={filteredDevices}
        columns={columns}
        rowKey={"Id"}
        pagination={{
          pageSizeOptions: ["10", "20", "50"],
          showSizeChanger: true,
          defaultPageSize: 10,
          showTotal: (total, range) =>
            t("pagination.showTotal", { start: range[0], end: range[1], total }),
        }}
      />

      {props.onLoading && <LoadingOverlay />}

      <AddDeviceModal
        visible={addVisible}
        action={props.registerDevice}
        close={closeAddModal}
        suggestions={props.roomSuggestions}
      />

      {updateVisible && (
        <UpdateDeviceModal
          visible={updateVisible}
          action={props.updateDevice}
          close={closeUpdateModal}
          selectedDevice={props.selectedDevice}
          suggestions={props.roomSuggestions}
          setDeviceConfig={props.setDeviceConfig}
        />
      )}

      {configureVisible && (
        <ConfigureDeviceModal
          visible={configureVisible}
          action={configureDevice}
          close={closeConfigureModal}
          selectedDevice={props.selectedDevice}
        />
      )}
      {checkDeviceConfigVisible && (
        <CheckDeviceConfigModal
          visible={checkDeviceConfigVisible}
          action={checkDeviceConfig}
          close={closeCheckDeviceConfigModal}
          selectedDevice={props.selectedDevice}
          data={deviceConfData}
        />
      )}
      {checkDeviceDebugVisible && (
        <DeviceDebugModal
          visible={checkDeviceDebugVisible}
          action={props.getDeviceTemperature}
          close={closeCheckDeviceDebugModal}
          selectedDevice={props.selectedDevice}
          data={props.deviceTemperature}
          errorLog={props.deviceErrorLog}
          getErrorLog={props.getDeviceErrorLog}
          triggerTestLog={props.triggerTestLog}
          setLogLevel={props.setDeviceLogLevel}
          startLogStream={props.startLogStream}
          stopLogStream={props.stopLogStream}
        />
      )}
    </Container>
	)
}

export default WithHOC(Devices)